export function serializeRoute(route) {
  if (!route) return null;

  const nestedPrevPage = typeof window !== 'undefined' ? window.history.state?.prevPage : null;

  return {
    name: route.name,
    params: { ...route.params },
    query: { ...route.query },
    ...(nestedPrevPage ? { state: { prevPage: nestedPrevPage } } : {}),
  };
}

export function withPrevPage(location, route) {
  if (!location) return null;

  return {
    ...location,
    state: {
      ...location.state,
      prevPage: serializeRoute(route),
    },
  };
}

export function collectMatchedMiddleware(matchedRoutes) {
  return matchedRoutes.reduce((guards, matchedRoute) => {
    const routeGuards = matchedRoute.meta.middleware
      ? matchedRoute.meta.middleware.filter(someGuard => !guards.includes(someGuard))
      : [];

    if (routeGuards && routeGuards.length) {
      return [...guards, ...routeGuards];
    }

    return guards;
  }, []);
}

export default collectMatchedMiddleware;
